// src/pages/BranchBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import BranchBalanceFilters from "./components/BranchBalanceFilters";
import BranchBalanceTable from "./components/BranchBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportBranchBalanceCsv } from "./components/exportBranchBalanceCsv";

const { Title } = Typography;

const BranchBalance = () => {
  const { message } = App.useApp();
  const { filters, list } = useSelector((state) => state.branchBalance); 
  const reportRef = useRef(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Branch Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportBranchBalanceCsv({
      list,
      title:    "Branch Balance Report",
      filename: "branch_balance",
    });
  };

  const hasData = list.length > 0;  
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Branch Balance Report
            </Title>
          }
  extra={
            <Flex gap={8}>
              {hasData && (                                      // 👈 conditional render
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
              >
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <BranchBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <BranchBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Branch Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <BranchBalanceTable pagination={false} printMode />
          )}
        />
      </div>
    </div>
  );
};

export default BranchBalance;
